package one.healthium.onboarding.ui.navigation

import androidx.compose.runtime.Composable
import one.healthium.onboarding.domain.configs.AdjustingPlanScreenConfig
import one.healthium.onboarding.domain.configs.AgeInputScreenConfig
import one.healthium.onboarding.domain.configs.CalculatingPersonalPlanScreenConfig
import one.healthium.onboarding.domain.configs.CoachIntroScreenConfig
import one.healthium.onboarding.domain.configs.CongratsScreenConfig
import one.healthium.onboarding.domain.configs.CongratsV2ScreenConfig
import one.healthium.onboarding.domain.configs.CongratsV3ScreenConfig
import one.healthium.onboarding.domain.configs.FastingLongTermResultsScreenConfig
import one.healthium.onboarding.domain.configs.FinalPersonalPlanScreenConfig
import one.healthium.onboarding.domain.configs.GenderScreenConfig
import one.healthium.onboarding.domain.configs.HeightInputScreenConfig
import one.healthium.onboarding.domain.configs.NameInputScreenConfig
import one.healthium.onboarding.domain.configs.NotificationsAccessScreenConfig
import one.healthium.onboarding.domain.configs.PersonalPlanScreenConfig
import one.healthium.onboarding.domain.configs.RelateToStatementScreenConfig
import one.healthium.onboarding.domain.configs.SelectableScreenConfig
import one.healthium.onboarding.domain.configs.TargetWeightInputScreenConfig
import one.healthium.onboarding.domain.configs.TextInputScreenConfig
import one.healthium.onboarding.domain.configs.TransparencyAccessScreenConfig
import one.healthium.onboarding.domain.configs.WeightInputScreenConfig
import one.healthium.onboarding.domain.configs.WelcomeScreenConfig
import one.healthium.onboarding.domain.configs.WellnessProfileScreenConfig
import one.healthium.onboarding.domain.configs.WellnessProfileV2ScreenConfig
import one.healthium.onboarding.domain.screens.ScreenDefinition
import one.healthium.onboarding.ui.screens.AdjustingPlanScreen
import one.healthium.onboarding.ui.screens.AgeInputScreen
import one.healthium.onboarding.ui.screens.CalculatingPersonalPlanScreen
import one.healthium.onboarding.ui.screens.CoachIntroScreen
import one.healthium.onboarding.ui.screens.CongratsScreen
import one.healthium.onboarding.ui.screens.CongratsV2Screen
import one.healthium.onboarding.ui.screens.CongratsV3Screen
import one.healthium.onboarding.ui.screens.FastingLongTermResultsScreen
import one.healthium.onboarding.ui.screens.FinalPersonalPlanScreen
import one.healthium.onboarding.ui.screens.GenderScreen
import one.healthium.onboarding.ui.screens.HeightInputScreen
import one.healthium.onboarding.ui.screens.NameInputScreen
import one.healthium.onboarding.ui.screens.NotificationAccessScreen
import one.healthium.onboarding.ui.screens.PersonalPlanScreen
import one.healthium.onboarding.ui.screens.RelateToStatementScreen
import one.healthium.onboarding.ui.screens.SelectableScreen
import one.healthium.onboarding.ui.screens.TargetWeightInputScreen
import one.healthium.onboarding.ui.screens.TextInputScreen
import one.healthium.onboarding.ui.screens.TransparencyAccessScreen
import one.healthium.onboarding.ui.screens.WeightInputScreen
import one.healthium.onboarding.ui.screens.WelcomeScreen
import one.healthium.onboarding.ui.screens.WellnessProfileScreen
import one.healthium.onboarding.ui.screens.WellnessProfileV2Screen

object ScreenDefinitionResolver {
    fun resolve(
        screenDefinition: ScreenDefinition,
        eventDelegate: GlobalInputEventDelegate,
    ): @Composable () -> Unit = {
        when (val screenConfig = screenDefinition.config) {
            is AdjustingPlanScreenConfig -> AdjustingPlanScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is CalculatingPersonalPlanScreenConfig -> CalculatingPersonalPlanScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is CongratsScreenConfig -> CongratsScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is CongratsV2ScreenConfig -> CongratsV2Screen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is CongratsV3ScreenConfig -> CongratsV3Screen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is FinalPersonalPlanScreenConfig -> FinalPersonalPlanScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is HeightInputScreenConfig -> HeightInputScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is NotificationsAccessScreenConfig -> NotificationAccessScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is PersonalPlanScreenConfig -> PersonalPlanScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is RelateToStatementScreenConfig -> RelateToStatementScreen(
                eventDelegate = eventDelegate,
                profileKey = screenDefinition.profileKey!!, // TODO Remove !! operator
                screenConfig = screenConfig,
            )

            is SelectableScreenConfig -> SelectableScreen(
                eventDelegate = eventDelegate,
                profileKey = screenDefinition.profileKey!!, // TODO: Remove !! operator
                screenConfig = screenConfig,
            )

            is TargetWeightInputScreenConfig -> TargetWeightInputScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is NameInputScreenConfig -> NameInputScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is AgeInputScreenConfig -> AgeInputScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is TransparencyAccessScreenConfig -> TransparencyAccessScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is WeightInputScreenConfig -> WeightInputScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is WellnessProfileScreenConfig -> WellnessProfileScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is WellnessProfileV2ScreenConfig -> WellnessProfileV2Screen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is CoachIntroScreenConfig -> CoachIntroScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is FastingLongTermResultsScreenConfig -> FastingLongTermResultsScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is GenderScreenConfig -> GenderScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )

            is TextInputScreenConfig -> TextInputScreen(
                eventDelegate = eventDelegate,
                profileKey = screenDefinition.profileKey!!, // TODO: Remove !! operator
                screenConfig = screenConfig,
            )

            is WelcomeScreenConfig -> WelcomeScreen(
                eventDelegate = eventDelegate,
                screenConfig = screenConfig,
            )
        }
    }
}